import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faFacebookF } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faPhone, faMapMarkerAlt, faDownload } from '@fortawesome/free-solid-svg-icons';


function Footer() {
  const currentYear = new Date().getFullYear();
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        setDeferredPrompt(null);
      }
    } else {
      // Fallback pour iOS ou si déjà installé
      alert("Pour installer l'application sur votre appareil :\nSur iPhone/iPad (Safari) : Touchez l'icône 'Partager' en bas, puis choisissez 'Sur l'écran d'accueil'.\nSur Android : Utilisez l'option 'Ajouter à l'écran d'accueil' du menu.");
    }
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.brandSection}>
          <Link to="/" className={styles.footerLogo}>
            <img src="/images/logo.png" alt="Maison Quinard Logo" />
          </Link>
          <p className={styles.brandPitch}>
            L’excellence artisanale de la construction bois pour vos projets de vie. Qualité, durabilité et design.
          </p>
          <div className={styles.socialLinks}>
            <a href="https://www.instagram.com/maison_bois_quinard/" target="_blank" rel="noopener noreferrer" className={styles.socialLink} aria-label="Instagram">
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a href="https://www.facebook.com/maison.quinard" target="_blank" rel="noopener noreferrer" className={styles.socialLink} aria-label="Facebook">
              <FontAwesomeIcon icon={faFacebookF} />
            </a>
          </div>

          <div className={styles.installSection}>
            <button onClick={handleInstallClick} className={styles.installButton} aria-label="Installer l'application">
              <FontAwesomeIcon icon={faDownload} className={styles.installIcon} />
              <span>Installer l'App</span>
            </button>
          </div>
        </div>

        <div className={styles.navSection}>
          <h3 className={styles.sectionTitle}>Navigation</h3>
          <ul className={styles.footerNavList}>
            <li><Link to="/services" className={styles.footerLink}>Services</Link></li>
            <li><Link to="/realisations" className={styles.footerLink}>Réalisations</Link></li>
            <li><Link to="/qui-sommes-nous" className={styles.footerLink}>Qui sommes-nous ?</Link></li>
            <li><Link to="/notre-cooperative" className={styles.footerLink}>Notre Coopérative</Link></li>
            <li><Link to="/contact" className={styles.footerLink}>Contact</Link></li>
          </ul>
        </div>

        <div className={styles.contactSection}>
          <h3 className={styles.sectionTitle}>Contact</h3>
          <ul className={styles.contactList}>
            <li>
              <FontAwesomeIcon icon={faMapMarkerAlt} className={styles.contactIcon} />
              <span>22 Rue du Paradis, 78790 Arnouville-lès-Mantes</span>
            </li>
            <li>
              <FontAwesomeIcon icon={faPhone} className={styles.contactIcon} />
              <a href="tel:+33658062720" className={styles.footerLink}>06 58 06 27 20</a>
            </li>
            <li>
              <FontAwesomeIcon icon={faEnvelope} className={styles.contactIcon} />
              <a href="mailto:contact@maison-quinard.com" className={styles.footerLink}>contact@maison-quinard.com</a>
            </li>
          </ul>
        </div>
      </div>

      <div className={styles.copyright}>
        <div className={styles.copyrightContainer}>
          <p>&copy; {currentYear} Maison Quinard. Tous droits réservés.</p>
          <div className={styles.legalLinks}>
            <Link to="/mentions-legales" className={styles.legalLink}>Mentions Légales</Link>
            <span className={styles.legalSeparator}>|</span>
            <a href="https://www.infocolab.com/" target="_blank" rel="noopener noreferrer" className={styles.legalLink}>
              Site réalisé par Infocolab
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}


export default Footer;
